import MenuIcon from "@mui/icons-material/Menu";
import {
  Box,
  Drawer,
  IconButton,
  ListItemButton,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import _ from "lodash";
import { useState } from "react";
import { CONSTANTS, GUIDE_URL, SECTIONS } from "../constants";
import { useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();
  const isHome = location.pathname === "/";
  return (
    <header>
      <Container maxWidth="lg" sx={{ paddingY: 2 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Link href="/" underline="none">
            <Typography variant="h3" color="primary">
              {CONSTANTS.appName}
            </Typography>
          </Link>
          <Menu isHome={isHome} />
        </Stack>
      </Container>
    </header>
  );
}

const Menu = ({ isHome }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  return isSmallScreen ? (
    <DrawerMenu />
  ) : (
    <Stack direction="row">
      {_.map(SECTIONS, (item) => {
        let link = isHome ? `#${_.toLower(item)}` : `/#${_.toLower(item)}`;
        if (item === SECTIONS.guide) {
          link = GUIDE_URL;
        }
        return (
          <Link
            key={item}
            underline="none"
            color="textPrimary"
            paddingX={1}
            href={link}
            target={item === SECTIONS.guide ? "_blank" : "_self"}
          >
            {item}
          </Link>
        );
      })}
    </Stack>
  );
};

const DrawerMenu = () => {
  const [isOpen, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen(!isOpen);
  };

  const onMenuClick = (id) => {
    toggleDrawer();
    if (id === _.toLower(SECTIONS.guide)) {
      window.open(GUIDE_URL, "_blank");
    } else {
      document.getElementById(id)?.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <IconButton onClick={toggleDrawer}>
        <MenuIcon color="primary" sx={{ fontSize: 20 }} />
      </IconButton>
      <Drawer open={isOpen} onClose={toggleDrawer} anchor="right" slotProps={{ paper: { elevation: 1} }}>
        <Box width={250}>
          {_.map(SECTIONS, (item) => {
            return (
              <ListItemButton
                key={item}
                onClick={() => onMenuClick(_.toLower(item))}
              >
                <ListItemText>{item}</ListItemText>
              </ListItemButton>
            );
          })}
        </Box>
      </Drawer>
    </>
  );
};

export default Header;
